import Reflux from 'reflux';
//import TapForSoundActions from './tap-for-sound-actions';
import VideoActionsFactory from 'medscape/video/video-actions-factory';
import ControlsActionsFactory from 'medscape/video/player-controls/controls-actions-factory';


class TapForSoundStore extends Reflux.Store {
  constructor(props) {
    super(props);
    this.videoActions = VideoActionsFactory.get(props.config, props.route);
    this.controlsActions = ControlsActionsFactory.get(props.config, props.route);
    this.state = this.getInitialState();
    this.listenTo(this.videoActions.volumechange,'onVideoVolumeChange');
  }
  getInitialState() {
    return {
      isVisible: true
    };
  }
  onVideoVolumeChange(mediaApi) {
    this.controlsActions.setVolume(mediaApi.getVolume());
    if(mediaApi.getMuted()==false || mediaApi.getVolume()>0){
      this.stopListeningTo(this.videoActions.volumechange);
      this.setState({
        isVisible: false
      })
    }
  }
}

export default TapForSoundStore ;



// WEBPACK FOOTER //
// ./medscape_modules/video/tap-for-sound/tap-for-sound-store.jsx